import { createContext } from '@chakra-ui/react-utils';
import type { SystemStyleObject } from '@chakra-ui/system';

import type { PromptBarPart } from './types';

export type PromptBarStyles = Partial<Record<PromptBarPart, SystemStyleObject>>;

const [PromptBarStylesProvider, usePromptBarStyles] =
  createContext<PromptBarStyles>({
    name: 'PromptBarStylesContext',
    strict: true,
    errorMessage:
      'usePromptBarStyles: `context` is undefined. Seems you forgot to wrap all menu components within `<PromptBar />`',
  });

export { PromptBarStylesProvider, usePromptBarStyles };
